class Lookbook extends HTMLElement {
    constructor() {
        super();
        
        // Écouter les clics sur l'image pour afficher les dots (mobile uniquement)
        const mediaElement = this.querySelector('.media');
        if (mediaElement && window.innerWidth < 750) {
            mediaElement.addEventListener('click', (event) => {
                // Si on clique sur l'image (pas sur un dot ou une card)
                if (!event.target.closest('.v2-lookbook__dots') && 
                    !event.target.closest('.v2-lookbook-card')) {
                    event.stopPropagation();
                    this.toggleDots();
                }
            });
        }
        
        // Écouter les clics sur les dots
        this.addEventListener('click', (event) => {
            const dot = event.target.closest('.v2-lookbook__dots');
            
            if (dot) {
                event.stopPropagation();
                this.toggleProduct(dot);
            }
        });
        
        // Fermer dots et cards quand on clique en dehors (DESKTOP + MOBILE)
        document.addEventListener('click', (event) => {
            // Si on clique en dehors du lookbook OU sur l'image de fond
            const clickedOutside = !event.target.closest('.v2-lookbook-card') && 
                                   !event.target.closest('.v2-lookbook__dots');
            
            if (clickedOutside) {
                // Fermer toutes les cards de tous les blocs
                document.querySelectorAll('.v2-lookbook-card').forEach(card => {
                    card.classList.remove('actif');
                });
                
                // Sur mobile, masquer aussi les dots
                if (window.innerWidth < 750) {
                    document.querySelectorAll('main-lookbook').forEach(block => {
                        block.classList.remove('show-dots');
                    });
                }
            }
        });
    }

    toggleDots() {
        // Toggle la classe "show-dots" pour afficher/masquer les dots
        this.classList.toggle('show-dots');
        
        // Si on cache les dots, on ferme aussi les cards
        if (!this.classList.contains('show-dots')) {
            this.closeAllProducts();
        }
    }

    toggleProduct(dot) {
        const card = dot.nextElementSibling;
        
        // Fermer toutes les autres cards de TOUS les blocs
        document.querySelectorAll('.v2-lookbook-card').forEach(c => {
            if (c !== card) {
                c.classList.remove('actif');
            }
        });
        
        // Toggle la card cliquée
        card.classList.toggle('actif');
    }

    closeAllProducts() {
        this.querySelectorAll('.v2-lookbook-card').forEach(card => {
            card.classList.remove('actif');
        });
    }
}

customElements.define('main-lookbook', Lookbook);